module.exports = __webpack_public_path__ + "img/page38.514f506f.gif";